import { useCallback, useState } from 'react';

import { BulkDeleteConfirmationProps } from './BulkDeleteConfirmation';

export type UseBulkDeleteConfirmationPropsReturnValue = {
  open: (rowIds: string[], onApply: () => void) => void;
  props: BulkDeleteConfirmationProps;
};

export function useBulkDeleteConfirmationProps(): UseBulkDeleteConfirmationPropsReturnValue {
  const [opened, setOpened] = useState(false);
  const [rowCount, setRowCount] = useState<number | undefined>();
  const [onApply, setOnApply] = useState<
    BulkDeleteConfirmationProps['onApply']
  >(() => undefined);

  const open = useCallback(
    (rowIds: string[], callback: () => void) => {
      setOpened(true);
      setRowCount(rowIds.length);
      setOnApply(() => () => {
        setOpened(false);
        callback();
      });
    },
    [setRowCount, setOnApply, setOpened]
  );

  return {
    open,
    props: {
      opened,
      rowCount,
      onApply,
      onClose: () => setOpened(false),
    },
  };
}
